import { render, staticRenderFns } from "./Article7.vue?vue&type=template&id=0569ff3b&"
import script from "./Article7.vue?vue&type=script&lang=js&"
export * from "./Article7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports